import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { RecentPurchases as RecentPurchasesComponent } from '@thd-olt-component-react/recent-order-details';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useNavigate } from '@thd-olt-component-react/router';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { HomepageContext } from './context/HomepageContext';

export function RecentPurchases() {
  const { isConsumerApp } = useContext(ExperienceContext);
  const { urlTmxId } = useContext(HomepageContext);
  const navigate = useNavigate();

  const onError = (error = {}) => {
    if (!isConsumerApp) return;

    const isSignInPath = window.location?.pathname?.includes('/auth/view/signin');
    const isUnauthorized = error?.graphQLErrors?.some((gqlError) => gqlError?.extensions['X-Http-Status-Code'] === 401);
    if (isUnauthorized && !isSignInPath) navigate('/auth/view/signin?redirect=/');
  };
  return (
    <ErrorBoundary name="recent-purchases">
      <QueryProvider cachekey="recent-purchases">
        <RecentPurchasesComponent onError={onError} urlTmxId={urlTmxId} />
      </QueryProvider>
    </ErrorBoundary>
  );
}
